<template>
    <div>
        <v-alert
            v-if="!(availableExtras.length === 0 && selectedExtras.length === 0)"
            type="info"
            style="margin-bottom: 0px; margin-top: 25px;"
        >
            A GyorsSzűrő a listában szereplő járművek eltérő felszereltsége alapján szűr, ezért nem szükséges minden
            felszereltség jelölése.
        </v-alert>
        <div style="margin-top: 30px;" v-if="availableExtras.length === 0 && selectedExtras.length === 0">
            A jelenlegi járműlista nem szűkíthető felszereltség alapján.
        </div>

        <div style="margin-top: 30px; font-weight: bold;"
             v-if="availableExtras.length === 0 && selectedExtras.length > 0">
            A listában szereplő járművek felszereltsége megegyezik.
        </div>

        <div class="scrollable-box" v-if="availableExtras.length > 0">
            <h3 style="margin-top: 25px;">
                Az alábbi listából válasszon ki néhány element, melyet biztosan tartalmaz a biztosítani kívánt jármű:
            </h3>
            <v-container>
                <v-row>
                    <v-col
                        md="6"
                        v-for="(col,index) in [1, 2]"
                        :key="index"
                    >
                        <v-row
                            v-for="(item,index) in sliceAvailableExtras(col)"
                            :key="index"
                        >
                            <v-col
                                cols="3"
                            >
                                <v-btn
                                    @click="chExtra('select', item)"
                                    x-small
                                >
                                    <span>Kiválaszt</span>
                                </v-btn>
                            </v-col>
                            <v-col
                                cols="9"
                            >
                                {{ item.name }}
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </v-container>
        </div>
        <div v-if="selectedExtras.length !== 0">
            <v-divider style="margin: 35px 0px;"/>
            <h4>A listában szereplő gépjárművek mindegyike tartalmazza:</h4>
            <ul style="margin-top: 10px;">
                <li
                    v-for="(item) in selectedExtras"
                    :key="item.value"
                    style="font-weight: bold; margin-bottom: 10px;"
                >
                    {{ item.name }}
                </li>
            </ul>
            <v-btn
                small
                @click="chExtra('reset')"
            >
                <span>Kiválasztottak törlése</span>
            </v-btn>
        </div>
    </div>
</template>
<script>
import { findSpecialExtras } from './utilities';

export default {
    name: 'FilterExtras',
    props: {
        cars: {},
        resetSelected: {},
    },

    watch: {
        resetSelected() {
            if (this.resetSelected) {
                this.selectedExtras = [];
                this.$emit('reseted');
            }
        },
        cars() {
            this.availableExtras = findSpecialExtras(this.cars);
        },
    },
    data() {
        return {
            availableExtras: [],
            selectedExtras: [],
        };
    },
    mounted() {
        this.availableExtras = findSpecialExtras(this.cars);
    },
    methods: {
        sliceAvailableExtras(col) {
            switch (col) {
            case 1:
                return this.availableExtras.slice(0, Math.ceil((this.availableExtras.length) / 2));
            case 2:
                return this.availableExtras.slice(
                    Math.ceil(this.availableExtras.length / 2),
                    this.availableExtras.length,
                );
            default:
                throw new Error('Something went wrong with sliceAvailableExtras.');
            }
        },
        chExtra(action, item = null) {
            switch (action) {
            case 'select':
                this.selectedExtras.push(item);
                this.$emit(
                    'filter-car',
                    [
                        {
                            name: 'extras',
                            input: this.selectedExtras,
                        },
                    ],
                    true,
                );
                break;
            case 'reset':
                this.selectedExtras = [];
                this.$emit(
                    'filter-car',
                    [
                        {
                            name: 'extras',
                            input: this.selectedExtras,
                        },
                    ],
                    true,
                );
                break;
            default:
                throw new Error('Something went wrong with chExtra');
            }
        },
    },
};
</script>
<style>
.centered-icon {
    width: 100%;
    height: 100%;
    margin: auto;
}

.scrollable-box {
    max-height: 60vh;
    overflow-y: scroll;
}

.db-field {
    margin-left: 15px;
    margin-bottom: 15px;
    margin-top: 15px;
}

</style>
